import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.TotalMaterial.WetSoilMass`]: wrap([
    `${prefix}.TotalMaterial.TareMass`,
    `${prefix}.TotalMaterial.WetSoilAndTareMass`,
  ]),
  [`${prefix}.CoarseMaterial.WetSoilMass`]: wrap([
    `${prefix}.CoarseMaterial.TareMass`,
    `${prefix}.CoarseMaterial.WetSoilAndTareMass`,
  ]),
  [`${prefix}.CoarseMaterial.DrySoilMass`]: wrap([
    `${prefix}.CoarseMaterial.TareMass`,
    `${prefix}.CoarseMaterial.DrySoilAndTareMass`,
  ]),
  [`${prefix}.PassingMaterial.WetSoilMass`]: wrap([
    `${prefix}.PassingMaterial.TareMass`,
    `${prefix}.PassingMaterial.WetSoilAndTareMass`,
  ]),
  [`${prefix}.PassingMaterial.DrySoilMass`]: wrap([
    `${prefix}.PassingMaterial.TareMass`,
    `${prefix}.PassingMaterial.DrySoilAndTareMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
